import Vue from "vue";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import { mixinDevice } from '@/utils/mixin.js';
import { jumpMixins } from "@/utils/jumpMixins";
import moment from "moment";
import pick from "lodash.pick";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import JSearchSelectTag from '@/components/jeecg/JSearchSelectTag';
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import JCategorySelect from "@comp/jeecg/JCategorySelect";
import JUpload from '@/components/jeecg/JUpload';
import EventPay from "./modal/EventPay";
// import EventApplySuccessModal from "./modal/EventApplySuccessModal"
import EventAppleNoticeModal from "./modal/EventAppleNoticeModal";
import PhotoModal from "@/components/user/PhotoModal";
import { filterMultiDictText } from "@comp/jeecg/JDictSelectUtil";
import { getQiniuUrl } from "@/utils/qiniu.js";
export default {
  name: "EventApply",
  mixins: [mixinDevice, jumpMixins],
  components: {
    JDictSelectTag: JDictSelectTag,
    JAreaLinkage: JAreaLinkage,
    JCategorySelect: JCategorySelect,
    JUpload: JUpload,
    EventPay: EventPay,
    // EventApplySuccessModal,
    EventAppleNoticeModal: EventAppleNoticeModal,
    PhotoModal: PhotoModal,
    JSearchSelectTag: JSearchSelectTag
  },
  data: function data() {
    return {
      visible: false,
      step: 0,
      confirmLoading: false,
      form: this.$form.createForm(this),
      model: {},
      eventId: "",
      eventInfo: {},
      userInfo: {},
      schoolType: 1,
      idcardType: 1,
      //1身份证 2护照 3其他
      applyPrice: 0,
      //报名费用
      applyEventInfo: {},
      categoryId: undefined,
      school: undefined,
      //默认机构学校
      useCode: false,
      //使用激活码
      applyConfig: {
        photo: 1,
        idcard: 2,
        sex: 1,
        grade: 1,
        email: 1,
        teacherName: 1,
        teacherPhone: 1,
        parentName: 1,
        parentPhone: 1,
        address: 1,
        school: 1
      },
      validatorRules: {
        activationCode: {
          rules: [{
            required: false,
            message: "请填写激活码"
          }, {
            validator: this.validateCode
          }]
        },
        photo: {
          rules: [{
            required: true,
            message: "请上传证件照!"
          }]
        },
        realname: {
          rules: [{
            required: true,
            message: "请输入真实姓名!"
          }]
        },
        idcard: {
          1: {
            rules: [{
              required: true,
              pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
              message: "请输入正确的身份证号码!"
            }]
          },
          2: {
            rules: [{
              required: true,
              pattern: /^([a-zA-z]|[0-9]){5,17}$/,
              message: "请输入正确的护照号码!"
            }]
          },
          3: {
            rules: [{
              required: true,
              message: "请输入其他证件号码!"
            }]
          }
        },
        // birthday: {
        //   initialValue: '1999-10-10',
        //   rules: [
        //     { required: true, message: "请输入生日!" },
        //     { validator: this.handleBirthdayCheck },
        //   ],
        //   validateTrigger: ["change", "blur"],
        //   validateFirst: true,
        // },
        grade: {
          rules: [{
            required: true,
            message: "请输入年级!"
          }]
        },
        schoolClass: {
          rules: [{
            required: false,
            message: "请输入班级!"
          }]
        },
        email: {
          rules: [{
            required: true,
            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "请输入正确的邮箱地址!"
          }]
        },
        teacherName: {
          rules: [{
            required: true,
            message: "请输入辅导老师姓名!"
          }]
        },
        teacherPhone: {
          rules: [{
            required: true,
            message: "请输入辅导老师手机号!",
            pattern: /^1[3456789]\d{9}$/
          }]
        },
        parentName: {
          rules: [{
            required: false,
            message: "请输入监护人姓名!"
          }]
        },
        parentPhone: {
          rules: [{
            required: false,
            message: "请输入监护人手机号!",
            pattern: /^1[3456789]\d{9}$/
          }]
        },
        sex: {
          rules: [{
            required: true,
            message: "请选择性别!"
          }]
        },
        school: {
          rules: [{
            required: true,
            message: "请填写学校/机构"
          }]
        },
        address: {
          rules: [{
            required: true,
            message: "请选择省市"
          }]
        },
        addressDetailed: {
          rules: [{
            required: true,
            message: "请填写快递地址"
          }]
        },
        eventCategory: {
          rules: [{
            required: true,
            message: "请选择报名类别"
          }]
        }
      }
    };
  },
  created: function created() {
    if (!Vue.ls.get(ACCESS_TOKEN)) {
      this.toLogin();
      return;
    }
    this.eventId = this.$route.query.id;
    this.getEventInfo(this.eventId);
    this.getUserInfo();
    if (window.location.hash == '#payok') {
      this.step = 2;
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.school = this.$route.query.school;
    if (this.school) {
      this.$nextTick(function () {
        _this.form.setFieldsValue({
          school: _this.school
        });
      });
    }
    this.categoryId = this.$route.query.cid;
    if (this.categoryId) {
      this.$nextTick(function () {
        _this.form.setFieldsValue({
          eventCategory: _this.categoryId
        });
      });
    }
  },
  methods: {
    handleBirthdayCheck: function handleBirthdayCheck(rule, value, callback) {
      var birthday = this.form.getFieldValue("birthday");
      var idcard = this.form.getFieldValue("idcard");
      if (birthday === undefined) {
        callback(new Error("请选择生日"));
      }
      birthday = birthday.format("YYYYMMDD");
      console.log(birthday);
      if (value && !idcard.includes(birthday)) {
        callback(new Error("生日和身份证信息不一致"));
      }
      callback();
    },
    getEventInfo: function getEventInfo(eventId) {
      var _this2 = this;
      this.confirmLoading = true;
      getAction('/teaching/teachingEvent/queryById', {
        id: eventId
      }).then(function (res) {
        if (res.success) {
          _this2.eventInfo = res.result;
          if (_this2.step == 0) {
            _this2.$refs.applyNotice.show(_this2.eventInfo.eventApplyNotice);
          }
          // if(this.eventInfo.defaultSearchSchool){
          //   this.$refs.searchTag.loadData(this.eventInfo.defaultSearchSchool)
          // }
          if (_this2.eventInfo.applyConfig) {
            _this2.applyConfig = JSON.parse(_this2.eventInfo.applyConfig);
          }
          _this2.validatorRules.photo.rules[0].required = _this2.applyConfig.photo == 2;
          _this2.validatorRules.email.rules[0].required = _this2.applyConfig.email == 2;
          _this2.validatorRules.address.rules[0].required = _this2.applyConfig.address == 2;
          _this2.validatorRules.addressDetailed.rules[0].required = _this2.applyConfig.addressDetailed == 2;
          _this2.validatorRules.school.rules[0].required = _this2.applyConfig.school == 2;
          _this2.validatorRules.sex.rules[0].required = _this2.applyConfig.sex == 2;
          _this2.validatorRules.parentName.rules[0].required = _this2.applyConfig.parentName == 2;
          _this2.validatorRules.parentPhone.rules[0].required = _this2.applyConfig.parentPhone == 2;
          _this2.validatorRules.teacherName.rules[0].required = _this2.applyConfig.teacherName == 2;
          _this2.validatorRules.teacherPhone.rules[0].required = _this2.applyConfig.teacherPhone == 2;
          _this2.validatorRules.grade.rules[0].required = _this2.applyConfig.grade == 2;
          _this2.validatorRules.schoolClass.rules[0].required = _this2.applyConfig.schoolClass == 2;
          _this2.validatorRules.idcard[1].rules[0].required = _this2.applyConfig.idcard == 2;
          _this2.validatorRules.idcard[2].rules[0].required = _this2.applyConfig.idcard == 2;
          _this2.validatorRules.idcard[3].rules[0].required = _this2.applyConfig.idcard == 2;
          _this2.confirmLoading = false;
        } else {
          _this2.$message.warning("活动不存在");
        }
      });
    },
    getUserInfo: function getUserInfo() {
      var that = this;
      getAction("/teaching/user/info").then(function (res) {
        if (res.success) {
          that.userInfo = res.result;
          that.$nextTick(function () {
            that.form.setFieldsValue(pick(that.userInfo, "idcard", "sex", "realname", "email", "photo", "grade", "phone"));
          });
        }
      });
    },
    validateCode: function validateCode(rule, value, callback) {
      var _this3 = this;
      if (value) {
        getAction("/teaching/teachingActivationCode/verifyCode?code=" + value).then(function (res) {
          if (res.success) {
            var codeInfo = res.result;
            if (codeInfo.agentId) {
              _this3.$nextTick(function () {
                _this3.form.setFieldsValue({
                  school: codeInfo.agentId
                });
              });
            }
            _this3.model.activationCode = value;
            callback();
          } else {
            _this3.model.activationCode = undefined;
            _this3.$nextTick(function () {
              _this3.form.setFieldsValue({
                school: undefined
              });
            });
            callback(res.message);
          }
        });
      }
    },
    //选择了项目，计算费用
    onEventCategoryChange: function onEventCategoryChange(value, label, data) {
      console.log(label);
      if (label.hasChild == 1) {
        return;
      }
      this.model.eventCategory = value;
      this.applyPrice = 0;
      for (var i in data) {
        if (data[i].customValue) {
          var config = JSON.parse(data[i].customValue);
          if (config.baseConfig && config.baseConfig.applyPrice) {
            console.log(label[i], config.baseConfig.applyPrice);
            var price = parseFloat(config.baseConfig.applyPrice);
            this.applyPrice += price;
          }
        }
      }
    },
    schoolSelected: function schoolSelected() {
      this.model.school = undefined;
      this.form.setFieldsValue({
        school: undefined
      });
    },
    showPhotoModal: function showPhotoModal() {
      if (this.step == 0) {
        this.$refs.photoModal.edit(1);
      }
    },
    photoChange: function photoChange(key, photoId) {
      console.log(key, photoId);
      this.form.setFieldsValue({
        photo: photoId
      });
      this.userInfo.photo = photoId;
      Vue.set(this.userInfo, "photo", photoId);
      Vue.set(this.userInfo, "photo_url", getQiniuUrl(key));
    },
    nextStep: function nextStep() {
      var that = this;
      if (that.step == 2) {
        this.$router.push({
          path: "/user/event"
        });
        return;
      }
      if (that.applyConfig.photo == 2 && !that.userInfo.photo_url) {
        that.$message.error("请上传证件照");
        return;
      }
      this.form.validateFields(function (err, values) {
        console.log(values);
        if (!err) {
          that.step = 1;
        }
      });
    },
    handleOk: function handleOk() {
      var that = this;
      if (that.applyConfig.photo == 2 && !that.userInfo.photo) {
        that.$message.error("请上传证件照");
        return;
      }
      this.form.validateFields(function (err, values) {
        console.log(values);
        if (!err) {
          that.confirmLoading = true;
          if (!values.birthday) {
            values.birthday = "";
          } else {
            values.birthday = values.birthday.format("YYYY-MM-DD");
          }
          values.id = that.applyEventInfo.id;
          values.eventId = that.eventId;
          values.photo = that.userInfo.photo;
          postAction("/teaching/teachingEventApply/apply", values).then(function (res) {
            if (res.success) {
              if (that.applyPrice > 0 && !that.useCode) {
                //需要报名费且未使用激活码，则支付订单
                var orderInfo = res.result;
                if (orderInfo) {
                  that.$refs.eventPay.open(orderInfo);
                } else {
                  that.step = 2;
                }
              } else {
                that.step = 2;
              }
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        } else {
          that.step = 1;
        }
      });
    },
    payOk: function payOk() {
      this.step = 2;
    },
    payError: function payError() {
      this.confirmLoading = false;
    }
  }
};